import { ZealApiResponse } from "@zeal/common";
import { IAxiosInstance } from "../../../AbstractApiClient/AbstractApiClient";
import {
  TGetWorkerI9MetricsAndStatsRequest,
  TGetWorkerI9MetricsAndStatsResponse,
} from "./getWorkerI9MetricsAndStats.schema";

export const getWorkerI9MetricsAndStats = (axios: IAxiosInstance) => {
  return async (params: TGetWorkerI9MetricsAndStatsRequest) => {
    const response = await axios.noRetry.get<
      ZealApiResponse<TGetWorkerI9MetricsAndStatsResponse>
    >(`/api/getWorkerI9MetricsAndStats`, {
      params,
    });
    const resData = response.data;
    if (resData.success) {
      return resData.data;
    }
    throw new Error("Something went wrong");
  };
};
